import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSidebarBuilding = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.25 19.51a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75M7.086 8.921a.75.75 0 0 1 .75-.75H8.7a.75.75 0 1 1 0 1.5h-.864a.75.75 0 0 1-.75-.75m0 3.323a.75.75 0 0 1 .75-.75H8.7a.75.75 0 0 1 0 1.5h-.864a.75.75 0 0 1-.75-.75m0 3.323a.75.75 0 0 1 .75-.75H8.7a.75.75 0 0 1 0 1.5h-.864a.75.75 0 0 1-.75-.75M15.025 13.352a.75.75 0 0 1 .75-.75h.864a.75.75 0 1 1 0 1.5h-.864a.75.75 0 0 1-.75-.75m0 3.323a.75.75 0 0 1 .75-.75h.864a.75.75 0 0 1 0 1.5h-.864a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.525 6.369A2.63 2.63 0 0 1 6.153 3.74h4.229a2.63 2.63 0 0 1 2.627 2.628v13.14a.75.75 0 0 1-1.5 0V6.37c0-.623-.505-1.128-1.127-1.128H6.153c-.623 0-1.128.505-1.128 1.128v13.14a.75.75 0 0 1-1.5 0z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.51 10.305a.75.75 0 0 1 .75-.75h5.677a2.63 2.63 0 0 1 2.627 2.627v7.327a.75.75 0 0 1-1.5 0v-7.327c0-.623-.504-1.127-1.127-1.127h-4.928v8.454a.75.75 0 0 1-1.5 0z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSidebarBuilding);
export default ForwardRef;
